import React from 'react';
import Phone from '../../../assets/images/Phone';
import Mail from '../../../assets/images/Mail';
import Location from '../../../assets/images/Location';
import { Col, Row } from 'reactstrap';

const ContactInfoCard = () => {
  return (
    <div className="contact-cards">
      <Row className="g-3 g-md-3 g-lg-3">
        <Col lg="3" md="6" sm="12" className="contact-card-col">
          <div className="card" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
            <div className="icon">
              <Phone />
            </div>
            <div>
              <a href="tel:+91 82205 38869">
                <p>+91 82205 38869</p>
              </a>
            </div>
          </div>
        </Col>
        <Col lg="3" md="6" sm="12" className="contact-card-col">
          <div className="card" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300">
            <div className="icon">
              <Mail />
            </div>
            <a href="mailto:team@legalligence.in">
              <p className="legalligence-email">team@legalligence.in</p>
            </a>
          </div>
        </Col>
        <Col lg="6" md="12" sm="12" className="contact-card-col">
          <div
            className="card last-info-card"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="400"
          >
            <div className="icon">
              <Location />
            </div>
            <p>
              #22, First floor, 5th Cross Street, Narayanasamy Naicker Nagar, Sholinganallur Chennai
              600119, Tamil Nadu, India
            </p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ContactInfoCard;
